import {
  useState,
  useEffect,
  useContext,
  Suspense,
  createContext,
} from "react";
import { Outlet } from "react-router-dom";
import messages from "@amzn/awsui-components-console/i18n/messages/all.en";
import { applyMode, Mode } from "@amzn/awsui-global-styles";
import TopNav from "./TopNav";
import { Helmet } from "react-helmet-async";
import { I18nProvider } from "@amzn/awsui-components-console/i18n";
import AppLayout from "@amzn/awsui-components-console/app-layout";
import Box from "@amzn/awsui-components-console/box";
import Spinner from "@amzn/awsui-components-console/spinner";

const LOCALE = "en";
interface LayoutContextProps {}

const LayoutContext = createContext<LayoutContextProps>({});

/**
 * No side nav or tools layout
 */
export default function LayoutNoNav() {
  const [darkMode, setDarkMode] = useState(isDarkMode());

  function isDarkMode(): boolean {
    if (localStorage.getItem("darkMode") === "true") {
      return true;
    }
    return false;
  }

  function enableDarkMode(newDarkMode: boolean) {
    localStorage.setItem("darkMode", "" + newDarkMode);
    setDarkMode(newDarkMode);
  }

  useEffect(() => {
    if (darkMode) {
      applyMode(Mode.Dark);
    } else {
      applyMode(Mode.Light);
    }
  }, [darkMode]);

  return (
    <I18nProvider locale={LOCALE} messages={[messages]}>
      <Helmet>
        <meta
          httpEquiv="Content-Security-Policy"
          content={`${import.meta.env.REACT_APP_CONTENT_SECURITY_POLICY}`}
        ></meta>
      </Helmet>
      <LayoutContext.Provider value={{}}>
        <div id="h" style={{ position: "sticky", top: 0, zIndex: 1002 }}>
          <TopNav isDarkMode={isDarkMode} enableDarkMode={enableDarkMode} />
        </div>
        <AppLayout
          headerSelector="#h"
          navigationHide={true}
          toolsHide={true}
          maxContentWidth={Number.MAX_VALUE}
          content={
            <Suspense
              fallback={
                <Box textAlign="center" padding="xxl">
                  <Spinner />
                </Box>
              }
            >
              <Outlet />
            </Suspense>
          }
        />
      </LayoutContext.Provider>
    </I18nProvider>
  );
}

export const useLayout = () => useContext(LayoutContext);
